export default __webpack_public_path__ + "static/media/Mask Group 4.7e0ba3e1.png";